﻿import React from 'react';
import PropTypes from 'prop-types';
import unsafeCharRegex from '../constants/unsafeCharRegex';
import { IMaskInput } from 'react-imask';

export default class TextBox extends React.Component {
    constructor(props) {
        super(props);

        this.onValueChange = this.onValueChange.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onAccept = this.onAccept.bind(this);
        this.validatePaste = this.validatePaste.bind(this);
    }

    testRegex(val) {
        let pattern = unsafeCharRegex;
        let regex = new RegExp(pattern);
        let test = regex.test(val);
        if (test) {
            return true;
        } else if (this.props.pattern) {
            pattern = this.props.pattern;
            regex = new RegExp(pattern);
            test = regex.test(val);
            return !test;
        }
        return false;
    }

    onValueChange(e) {
        let val = e.target.value;
        if (val && this.testRegex(val)) {
            e.preventDefault();
        }
        else {
            this.props.onChange(val);
        }
    }

    onKeyPress(e) {
        let key = e.key;
        if (this.testRegex(key)) {
            e.preventDefault();
        }
    }

    onBlur(e) {
        let val = e.target.value;
        this.props.onBlur(val);
    }

    onFocus(e) {
        let val = e.target.value;
        this.props.onFocus(val);
    }

    onAccept(e) {
        this.onValueChange(e);
    }

    validatePaste(e) {
        const copiedText = e.clipboardData.getData('text');
        if (this.testRegex(copiedText)) {
            e.preventDefault();
            return false;
        }
    }

    render() {
        let successState = null;
        if (this.props.isValid !== null && this.props.isValid !== undefined) {
            if (this.props.isValid) {
                successState = "is-valid";
            }
            else {
                successState = "is-invalid";
            }
        }
        let className = this.props.hiddenLabel ? "hidden-label " : this.props.staticLabel ? "static-placeholder " : "animated-placeholder ";
        if (this.props.icon) className += "input-icon ";
        if (this.props.className) {
            className += this.props.className;
        }
        let type = this.props.type ? this.props.type : "text";
        return (
            <div className={className}>
                {(this.props.staticLabel || this.props.hiddenLabel) &&
                    <>
                        <label htmlFor={this.props.id}>
                            {this.props.label}
                        </label>
                        {this.props.help}
                    </>
                }
                {this.props.mask ?
                    <IMaskInput
                        type={type}
                        mask={this.props.mask}
                        radix={this.props.radix}
                        id={this.props.id}
                        className={successState ? "form-control " + successState : "form-control"}
                        value={this.props.value}
                        onAccept={this.props.onChange}
                        onKeyPress={this.onKeyPress}
                        required={this.props.required}
                        maxLength={this.props.maxLength ? this.props.maxLength : null}
                        disabled={this.props.disabled}
                        onFocus={this.onFocus}
                        onBlur={this.onBlur}
                        autoComplete={this.props.autoComplete}
                        placeholder={this.props.placeholder}
                        unmask="typed"
                        defaultValue={this.props.value}
                        inputMode={this.props.inputMode ? this.props.inputMode : null}
                        ref={this.props.inputRef}
                        autoFocus={this.props.autoFocus}
                    />
                    :
                    <input
                        type={type}
                        id={this.props.id}
                        className={successState ? "form-control " + successState : "form-control"}
                        value={this.props.value}
                        onChange={this.onValueChange}
                        onKeyPress={this.onKeyPress}
                        required={this.props.required}
                        maxLength={this.props.maxLength ? this.props.maxLength : null}
                        disabled={this.props.disabled}
                        onFocus={this.onFocus}
                        onBlur={this.onBlur}
                        autoComplete={this.props.autoComplete}
                        placeholder={this.props.placeholder}
                        onPaste={this.validatePaste}
                        inputMode={this.props.inputMode ? this.props.inputMode : null}
                        ref={this.props.inputRef}
                        autoFocus={this.props.autoFocus}
                    />
                }
                {!this.props.staticLabel && !this.props.hiddenLabel &&
                    <>
                        <label htmlFor={this.props.id}>
                            {this.props.label}
                        </label>
                        {this.props.help}
                    </>
                }
                {this.props.icon && this.props.icon}
                {this.props.invalidFeedback && (
                    <div className="invalid-feedback text">
                         <span className='invalid-icon'/>
                         {this.props.invalidFeedback}
                    </div>
                )}
            </div>
        );
    }
}

TextBox.propTypes = {
    type: PropTypes.string,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    hiddenLabel: PropTypes.bool,
    icon: PropTypes.element,
    id: PropTypes.string.isRequired,
    invalidFeedback: PropTypes.string,
    isValid: PropTypes.bool,
    label: PropTypes.string,
    mask: PropTypes.string,
    maxLength: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    required: PropTypes.bool,
    staticLabel: PropTypes.bool,
    value: PropTypes.string.isRequired,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    autoComplete: PropTypes.string,
    help: PropTypes.object,
    radix: PropTypes.string,
    placeholder: PropTypes.string,
    inputRef: PropTypes.any,
    inputMode: PropTypes.string
};

TextBox.defaultProps = {
    onBlur: () => { },
    onFocus: () => { },
    autoComplete: null,
    placeholder: '',
    autoFocus: false,
};